import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import DataTable from "react-data-table-component";
import * as api from "../services/apiService";

const CustomDataTable = forwardRef(({
  columns,
  title,
  fetchUrl,
  filters,
}, ref) => {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [page, setPage] = useState(1);

  useImperativeHandle(ref, () => ({
    refresh: () => fetchData(page, perPage),
  }));

  async function fetchData(pageNumber = page, pageSize = perPage) {
    setLoading(true);

    const pagination = {
      pageSize: pageSize,
      pageNumber: pageNumber,
    };

    const response = await api.post(fetchUrl, {
      options: filters,
      pagination: pagination,
    }, { authorize: true });
    const data = await response.json();

    setData(data.records);
    setTotalRows(data.total);
    setLoading(false);
  }

  function handlePageChange(newPage) {
    setPage(newPage);
    fetchData(newPage, perPage); // Pass the updated page to fetchData
  }

  async function handlePerRowsChange(newPerPage, newPage) {
    setPerPage(newPerPage);
    setPage(newPage);
    fetchData(newPage, newPerPage); // Pass the updated perPage to fetchData
  }

  useEffect(() => {
    fetchData(page, perPage);
  }, [page, perPage]); // Refetch data when page or perPage changes

  return (
    <DataTable
      className="table-stripped"
      columns={columns}
      data={data}
      fixedHeader
      title={title}
      pagination
      paginationServer
      progressPending={loading}
      paginationTotalRows={totalRows}
      onChangeRowsPerPage={handlePerRowsChange}
      onChangePage={handlePageChange}
      theme="dark"
    />
  );
});

export default CustomDataTable;
